/**
 * BUSINESS REDUCER
 *
 * Redux reducer for Business state management.
 * See: /BUSINESS_MODEL_ARCHITECTURE.md
 *
 * STATE SHAPE:
 * {
 *   currentBusiness: { _id, storeName, ... } | null,
 *   myBusinesses: [{ _id, storeName, userRole, ... }],
 *   loading: boolean,
 *   error: string | null
 * }
 *
 * CREATED: May 2025
 */

const initialState = {
  currentBusiness: null,    // The active business the user is working in
  myBusinesses: [],         // All businesses user owns or is team member of
  loading: false,
  error: null
};

export const businessReducer = (state = initialState, action) => {
  switch (action.type) {
    case "BUSINESS_LOADING":
      return {
        ...state,
        loading: true,
        error: null
      };

    case "BUSINESS_ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case "SET_CURRENT_BUSINESS":
      // Set the current/active business
      return {
        ...state,
        currentBusiness: action.payload,
        loading: false,
        error: null
      };

    case "SET_MY_BUSINESSES":
      // Set all businesses user has access to
      return {
        ...state,
        myBusinesses: action.payload,
        loading: false,
        error: null
      };

    case "UPDATE_CURRENT_BUSINESS":
      // Update fields in current business
      return {
        ...state,
        currentBusiness: state.currentBusiness
          ? { ...state.currentBusiness, ...action.payload }
          : null
      };

    case "ADD_BUSINESS":
      // Add a new business to the list
      return {
        ...state,
        myBusinesses: [...state.myBusinesses, action.payload]
      };

    case "REMOVE_BUSINESS":
      // Remove a business from the list (e.g., when leaving a team)
      return {
        ...state,
        myBusinesses: state.myBusinesses.filter(b => b._id !== action.payload),
        currentBusiness: state.currentBusiness?._id === action.payload
          ? null
          : state.currentBusiness
      };

    case "CLEAR_BUSINESS":
      // Clear business state (e.g., on logout)
      return initialState;

    case "LOGOUT":
      // Also clear on logout
      return initialState;

    default:
      return state;
  }
};

export default businessReducer;
